import {
    ImageField,
    TextField,
    useRecordContext,
    RichTextField,
    Show,
    SimpleShowLayout,
    useTranslate,
    usePermissions,
    useNotify,
} from "react-admin";
import { Button, Box, Grid } from "@mui/material";
import { downloadFile } from "shared/src/utils/downloadHandler";

export const ShowView = ({ mediaTools, setMediaTools, isFullscreen = false }) => {
    const translate = useTranslate();
    const notify = useNotify();
    const { isLoading, permissions } = usePermissions();

    if (isLoading) {
        return <></>;
    }
    return (
        <Show resource="media" id={mediaTools.id} sx={{ height: isFullscreen ? "100vh" : "auto" }}>
            <Grid
                container
                sx={{
                    p: 2,
                    height: isFullscreen ? "calc(100vh - 110px)" : "auto",
                    maxWidth: "1350px",
                    mx: "auto",
                    px: 5
                }}
            >
                <Grid size={{ sm: mediaTools.record?._links.thumbnail ? 4 : 12 }}>
                    <SimpleShowLayout>
                        <TextField source="type" />
                        <TextField label="equip.name" source="shortname" />
                        {mediaTools.type === "text" && (
                            <Box
                                sx={{
                                    maxHeight: isFullscreen ? "calc(100vh - 300px)" : "500px",
                                    overflowY: "auto",
                                    "& img": {
                                        maxWidth: "100%",
                                        height: "auto",
                                        display: "block",
                                    },
                                }}
                            >
                                <RichTextField
                                    sx={{ padding: "0 25px 0 0", overflowWrap: "anywhere" }}
                                    source="content"
                                />
                            </Box>
                        )}
                        {mediaTools.type === "link" && <ExternalLink />}
                    </SimpleShowLayout>
                </Grid>
                <Grid size={{ sm: mediaTools.record?._links.thumbnail ? 7 : 0 }}>
                    {mediaTools.record?.mimetype !== "application/pdf" && (
                        <SimpleShowLayout>
                            {mediaTools.record?._links.thumbnail && (
                                <ImageField label="equip.preview" source="_links.thumbnail" />
                            )}
                        </SimpleShowLayout>
                    )}
                </Grid>
            </Grid>
            <Box sx={{ px: 4, pb: 2, display: "flex", justifyContent: "space-between" }}>
                {mediaTools.type === "file" &&
                permissions.vote({
                    resource: "media",
                    attribute: "download",
                    subject: mediaTools.record,
                }) ? (
                    <Button
                        disabled={!mediaTools.record}
                        onClick={() => {
                            downloadFile(
                                mediaTools.record._links.download,
                                null,
                                mediaTools.record.shortname,
                                notify
                            );
                        }}
                        title={translate("equip.download")}
                        aria-label={translate("equip.download")}
                    >
                        {translate("equip.download")}
                    </Button>
                ) : (
                    <Box />
                )}
                <Button
                    onClick={() =>
                        setMediaTools({
                            edit: null,
                            type: null,
                            id: null,
                            record: null,
                        })
                    }
                    title={translate("equip.close")}
                    aria-label={translate("equip.close")}
                >
                    {translate("equip.close")}
                </Button>
            </Box>
        </Show>
    );
};

const ExternalLink = () => {
    const record = useRecordContext();
    return (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a href={record.url} target="_blank">
            {record.url}
        </a>
    );
};
